import React, { Component } from 'react'
import Included from '../Included'
class Breakpoints extends Component {

  constructor(props) {
    super(props)
  }

  render (){
    return(
      <section><a className="anchor"id="breakpoints"></a>
      <h2>Breakpoints</h2>
      <p>Common UI styling is developed mobile first by design. Breakpoints are based on minimum viewport widths and allow us to change styling, scaling or layout as the viewport changes.</p>
      <p>Common UI uses the following media query ranges in our source files. Some target a specific range and some target from the specified width up. In the source, these are defined in em units,
      here they are shown in pixels. The most commonly used breakpoints throughout Common UI are <code>xs-and-up</code>, <code>sm-and-up</code>, <code>md-and-up</code> and <code>lg-and-up</code>. These
      can be seen in the examples after each component.</p>
      <pre><code className="language-js">{`'xs-only'     'screen and (max-width: 479.04px)'
'xs-and-up'   'screen and (min-width: 480px)'
'sm-only'     'screen and (min-width: 480px) and (max-width: 767.04px)'
'sm-and-up'   'screen and (min-width: 768px)'
'md-only'     'screen and (min-width: 768px) and (max-width: 991.04px)'
'md-and-up'   'screen and (min-width: 992px)'
'lg-only'     'screen and (min-width: 992px) and (max-width: 1199.04px)'
'lg-and-up'   'screen and (min-width: 1200px)'
'xlg-only'    'screen and (min-width: 1200px) and (max-width: 1599.04px)'
'xlg-and-up'  'screen and (min-width: 1600px)'

'retina'      '(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi), (min-resolution: 2dppx)'
'ie'          'screen and (-ms-high-contrast: active), (-ms-high-contrast: none)'`}</code></pre><br/>
      <p>This compiles to:</p>
      <pre><code className="language-css">{`@media screen and (max-width: 479.04px) { /* Insert styles */ } /* XS only */
@media screen and (min-width: 480px) { /* Insert styles */ } /* XS and up */
@media screen and (min-width: 480px) and (max-width: 767.04px) { /* Insert styles */ } /* SM only */
@media screen and (min-width: 768px) { /* Insert styles */ } /* SM and up */
@media screen and (min-width: 768px) and (max-width: 991.04px) { /* Insert styles */ } /* MD only */
@media screen and (min-width: 992px) { /* Insert styles */ } /* MD and up */
@media screen and (min-width: 992px) and (max-width: 1199.04px) { /* Insert styles */ } /* LG only */
@media screen and (min-width: 1200px) { /* Insert styles */ } /* LG and up */
@media screen and (min-width: 1200px) and (max-width: 1599.04px) { /* Insert styles */ } /* XLG only */
@media screen and (min-width: 1600px) { /* Insert styles */ } /* XL and up */

@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi), (min-resolution: 2dppx) { /* Insert styles */ } /* Retina */
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) { /* Insert styles */ } /* IE */
`}</code></pre><br/>
    <p>There are additional values for targeting retina screens and IE. Common UI provides these as SASS functions so these are intended to be use as such in application source:</p>
    <pre><code className="language-js">{`@include media-query(lap-and-up) { .. }`}</code></pre><br/>
    <p>It is intended that your application's styles adhere to the same breakpoints as outlined here. Failure to do this will result in an
    unscalable, inconsistent UI.</p>
    <pre><code className="language-js">{`// Example: Hide starting at 'min-width: 0', and then show at the 'sm-and-up' breakpoint
.custom-class {
  display: none;
}

@include media-query(sm-and-up) {
  .custom-class {
    display: block;
  }
}`}</code></pre>
        <br/>
        <hr />
        </section>
      )
    }
}

export default Breakpoints



// WEBPACK FOOTER //
// ./styleguide/components/sections/Breakpoints.js